"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_data_table_component_1 = __importDefault(require("react-data-table-component"));
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const GlobalModal_1 = require("../../common/js/components/GlobalModal");
const ScopeGuard_1 = __importDefault(require("../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../common/js/enums/AuthorizationScopes"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = require("../../common/js/stores/AuthorizationStore");
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const DataTableTheme_1 = __importDefault(require("../enums/DataTableTheme"));
const ReturnStore_1 = __importDefault(require("../stores/ReturnStore"));
const ReturnConfirmationModal_1 = __importDefault(require("./ReturnConfirmationModal"));
const dataTableStyles = {
    headRow: {
        style: {
            minHeight: '1.625rem',
        },
    },
    headCells: {
        style: {
            color: _variables_scss_1.default.gray_400,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            fontWeight: 'normal',
            minHeight: '2.875rem',
            overflow: 'visible',
        },
    },
    rows: {
        style: {
            borderTopWidth: '1px',
            borderTopColor: _variables_scss_1.default.gray_200,
            borderTopStyle: 'solid',
            paddingTop: '0.5rem',
        },
    },
    cells: {
        style: {
            fontSize: _variables_scss_1.default.font_size_base,
            lineHeight: '1.5rem',
            minHeight: '4.5rem',
        },
    },
    expanderCell: {
        style: {
            flex: '0 0 3.125rem',
        },
    },
};
const TableTileReturn = ({ columns, data, expandableComponent, noDataText, scrollInside, title, }) => {
    const tableRef = (0, react_1.useRef)(null);
    const tableHeaderRef = (0, react_1.useRef)(null);
    const onScrollInput = (0, react_1.useCallback)(() => {
        const tableHead = tableRef.current?.querySelector('.rdt_TableHead');
        const tableHeadRect = tableRef.current?.getBoundingClientRect();
        const tileHeadRect = tableHeaderRef.current?.getBoundingClientRect();
        if (!tileHeadRect || !tableHeadRect || !tableHead) {
            return;
        }
        const distanceOffset = -0.5;
        const tableHeaderStickyTop = Math.floor((tileHeadRect.top ?? 0) + (tileHeadRect.height ?? 0) - (tableHeadRect.top ?? 0));
        if (tableHeaderStickyTop > 0) {
            tableHead.style.transform = `translateY(${tableHeaderStickyTop + distanceOffset}px)`;
            tableHead.style.backgroundColor = '#fff';
            tableHead.style.zIndex = '1000';
            tableHead.style.borderBottom = '1px solid #d1dae1';
        }
        else {
            tableHead.style.transform = '';
            tableHead.style.backgroundColor = '';
            tableHead.style.zIndex = '';
            tableHead.style.borderBottom = '';
        }
    }, []);
    (0, react_1.useEffect)(() => {
        document.addEventListener('scroll', onScrollInput);
        return () => {
            document.removeEventListener('scroll', onScrollInput);
        };
    }, [onScrollInput]);
    const showModal = () => {
        (0, GlobalModal_1.showModal)({
            component: ReturnConfirmationModal_1.default,
            props: {},
        }).then(() => {
            react_toastify_1.toast.success((0, translation_1.t)('modal.returns.delivery.success', {
                channel: AuthorizationStore_1.AuthorizationStore.name,
            }));
        });
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('znd-table-tile', { 'znd-table-tile--inner-scroll': scrollInside }) },
        react_1.default.createElement("div", { className: "d-flex align-items-start znd-table-tile__header", ref: tableHeaderRef }, title ? react_1.default.createElement("div", { className: "znd-table-tile__header-title t-card-title" }, title) : null),
        noDataText ?? null,
        react_1.default.createElement("div", { className: "znd-table-tile__scroll-wrapper", ref: tableRef },
            react_1.default.createElement(react_data_table_component_1.default, { className: "znd-table-tile__table pt-2", columns: columns, data: data, theme: DataTableTheme_1.default.main, noHeader: true, customStyles: dataTableStyles, expandOnRowClicked: false, expandableRows: !!expandableComponent, expandableRowsComponent: expandableComponent, expandableRowExpanded: () => true, responsive: false, sortIcon: react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.caretDown, className: "znd-table-tile__icon-caret ml-2" }), noDataComponent: noDataText, expandableRowsHideExpander: true })),
        react_1.default.createElement("div", { className: "znd-table-tile__footer" },
            react_1.default.createElement("div", { className: "znd-table-tile__footer__content" },
                react_1.default.createElement("div", { className: "znd-table-tile__footer__item" }, ReturnStore_1.default.hasSelectedReturns && (react_1.default.createElement("div", { className: "d-flex justify-content-center" },
                    react_1.default.createElement("i", { className: "znd-table-tile__footer__icon icon-check" }),
                    react_1.default.createElement("span", null, (0, translation_1.t)('myassets.returns.table.items_selected', { count: ReturnStore_1.default.totalReturns }))))),
                react_1.default.createElement("div", { className: "znd-table-tile__footer__item" },
                    react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.RETURN_UPDATE] },
                        react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, className: "znd-shop-product-page__bottom-read-more", text: (0, translation_1.t)('myassets.returns.button.create_return_delivery'), disabled: !ReturnStore_1.default.hasSelectedReturns, onClick: () => {
                                Object.values(ReturnStore_1.default.selectedRmas).forEach((rma) => {
                                    ReturnStore_1.default.setErrors(rma.id);
                                });
                                if (ReturnStore_1.default.isValid()) {
                                    showModal();
                                }
                            } })))))));
};
exports.default = (0, mobx_react_1.observer)(TableTileReturn);
